module.exports = "images/france-2.224bf090.png";